import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

interface UserInfo {
  readonly UserId: string;
}

@Injectable({ providedIn: 'root' })
export class MetricsService {
  private readonly id = 104041294;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  sendUserInfo(userInfo: UserInfo): void {
    this.sendCommand('userParams', userInfo);
  }

  private sendCommand(command: string, data: any): void {
    (<any>this.document.defaultView)?.ym(this.id, command, data);
  }
}
